import { render, staticRenderFns } from "./PromotionPopup.vue?vue&type=template&id=29ad4d74&scoped=true"
import script from "./PromotionPopup.vue?vue&type=script&lang=js"
export * from "./PromotionPopup.vue?vue&type=script&lang=js"
import style0 from "./PromotionPopup.vue?vue&type=style&index=0&id=29ad4d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ad4d74",
  null
  
)

export default component.exports